import { pick, toNumber } from "@components/health/clients/health-clients-utils";

export const KKM_MAX_DEPS = 10;

export const VID_KKM_SD_UDS = 501;
export const VID_KKM_ONLINE_SBERBANK = 601;
export const VID_KKM_EXTERNAL_PMS = 701;

/** Как Delphi KKM_LoadCmb. */
export const VID_KKM_OPTIONS = [
  { value: 0, label: "Не является ККМ" },
  { value: 100, label: "АТОЛ. Наличные" },
  { value: 91, label: "АТОЛ. Тип оплаты 1" },
  { value: 92, label: "АТОЛ. Тип оплаты 2" },
  { value: 93, label: "АТОЛ. Тип оплаты 3" },
  { value: 94, label: "АТОЛ. Тип оплаты 4" },
  { value: 95, label: "АТОЛ. Тип оплаты 5" },
  { value: 101, label: "Штрих. Наличные" },
  { value: 102, label: "Штрих. Оплата типа 1" },
  { value: 103, label: "Штрих. Оплата типа 2" },
  { value: 104, label: "Штрих. Оплата картой" },
  { value: 111, label: "Poscenter. Наличные" },
  { value: 112, label: "Poscenter. Оплата типа 1" },
  { value: 113, label: "Poscenter. Оплата типа 2" },
  { value: 114, label: "Poscenter. Оплата картой" },
  { value: 200, label: "Проффит. Наличные" },
  { value: 201, label: "Проффит. Тип оплаты 1" },
  { value: 202, label: "Проффит. Тип оплаты 2" },
  { value: 203, label: "Проффит. Тип оплаты 3" },
  { value: 204, label: "Проффит. Тип оплаты 4" },
  { value: 205, label: "Проффит. Тип оплаты 5" },
  { value: 301, label: "Windows принтер" },
  { value: VID_KKM_SD_UDS, label: "Система лояльности UDS.APP" },
  { value: VID_KKM_ONLINE_SBERBANK, label: "Сбербанк-ссылка" },
  { value: VID_KKM_EXTERNAL_PMS, label: "Внешняя PMS" }
];

export const VID_KKM_LABELS = Object.fromEntries(VID_KKM_OPTIONS.map((o) => [o.value, o.label]));

/** Как Delphi KKM_LoadSNOCmb. */
export const SNO_OPTIONS = [
  { value: 0, label: "По умолчанию" },
  { value: 1, label: "Общая СН" },
  { value: 2, label: "Упрощённая доход" },
  { value: 3, label: "Упрощённая доход минус расход" },
  { value: 4, label: "ЕНВД" },
  { value: 5, label: "Единый сельскохозяйственный налог" },
  { value: 6, label: "Патентная СН" }
];

/** Как Delphi GetUserLaw: отсутствующий бит = разрешено. */
export const getLawFlag = (law, index) => {
  if (!law || law.length <= index) return 1;
  const n = Number(law[index]);
  return Number.isFinite(n) ? n : 1;
};

export const normalizeKassa = (row) => ({
  idKassa: toNumber(pick(row, "idKassa", "IdKassa")),
  name: pick(row, "name", "Name") ?? "",
  kassirName: pick(row, "kassirName", "KassirName") ?? "",
  prc: toNumber(pick(row, "prc", "Prc")) ?? 0,
  sn: pick(row, "sn", "Sn") ?? "",
  isHide: toNumber(pick(row, "isHide", "IsHide")) ?? 0,
  vid: toNumber(pick(row, "vid", "Vid")) ?? 0,
  taxes: pick(row, "taxes", "Taxes") ?? "",
  isTerm: toNumber(pick(row, "isTerm", "IsTerm")) ?? 0,
  sno: pick(row, "sno", "Sno") ?? "",
  sdUser: pick(row, "sdUser", "SdUser") ?? "",
  sdPassword: pick(row, "sdPassword", "SdPassword") ?? "",
  idBranch: toNumber(pick(row, "idBranch", "IdBranch")) ?? 0,
  sdFinishUrl: pick(row, "sdFinishUrl", "SdFinishUrl") ?? "",
  sdFailUrl: pick(row, "sdFailUrl", "SdFailUrl") ?? "",
  branchName: pick(row, "branchName", "BranchName") ?? ""
});

export const normalizeBranch = (row) => ({
  id: toNumber(pick(row, "id", "Id")),
  name: pick(row, "name", "Name") ?? ""
});

/** Delphi FillTable: TAXES hex digits + SNO digits → 10 department rows. */
export const unpackDeps = (taxes, sno) => {
  const t = String(taxes || "");
  const s = String(sno || "");
  const rows = [];
  for (let i = 1; i <= KKM_MAX_DEPS; i += 1) {
    const taxChar = t.length >= i ? t[i - 1] : "0";
    const snoChar = s.length >= i ? s[i - 1] : "0";
    const tax = Number.parseInt(taxChar, 16);
    const snoVal = Number.parseInt(snoChar, 10);
    rows.push({
      depno: i,
      tax: Number.isFinite(tax) ? tax : 0,
      sno: Number.isFinite(snoVal) ? snoVal : 0
    });
  }
  return rows;
};

/** Delphi GetTable: pack department rows into TAXES/SNO strings. */
export const packDeps = (deps) => {
  let taxes = "";
  let sno = "";
  for (let i = 1; i <= KKM_MAX_DEPS; i += 1) {
    const row = Array.isArray(deps) ? deps.find((d) => d.depno === i) : null;
    const tax = Math.min(15, Math.max(0, Number(row?.tax) || 0));
    const snoVal = Math.min(9, Math.max(0, Number(row?.sno) || 0));
    taxes += tax.toString(16).toUpperCase();
    sno += String(snoVal);
  }
  return { taxes, sno };
};
